module.exports = __webpack_public_path__ + "images/9b7423e1ac4c35f2f47c6e6c72f0bd81.jpg";